export enum MailAccountElasticSearchIndexState {
  Active = 1,
  Disabled = 2,
}
